"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResponseBody = exports.parseAirrorResponse = exports.parsePath = exports.encodeQueryParams = void 0;
const errors_1 = require("@air/errors");
const querystring_1 = require("querystring");
const encodeQueryParams = (data) => (0, querystring_1.stringify)(Object.entries(data).reduce((res, [key, val]) => {
    if (val !== undefined && val !== null) {
        res[key] = typeof val === 'object' ? JSON.stringify(val) : val;
    }
    return res;
}, {}));
exports.encodeQueryParams = encodeQueryParams;
const parsePath = (input) => {
    const args = Object.assign({}, input.args);
    const path = input.path.replace(/:([^/]*)/g, (match, key) => {
        const result = args[key];
        if (result === undefined) {
            throw new Error(`Missing path parameter '${key}' in args:`, args);
        }
        delete args[key];
        return result;
    });
    return { path, args };
};
exports.parsePath = parsePath;
const STATUS_CODE_TO_AIRROR = {
    404: errors_1.NOT_FOUND,
    414: errors_1.URI_LENGTH_TOO_LONG,
    429: errors_1.THROTTLED,
    500: errors_1.INTERNAL_ERROR,
    502: errors_1.BAD_GATEWAY,
    504: errors_1.REQUEST_TIMED_OUT,
};
const parseAirrorResponse = ({ body, status, }) => {
    if ((0, errors_1.isAirrorPayload)(body)) {
        return new errors_1.Airror(body);
    }
    // TODO: revisit this by making all sdk methods typed with possible airrors
    // even if they did not originate from the server so that a throw is not necessary
    // https://linear.app/air/issue/ENG-50/update-sdk-to-be-more-intelligent-with-returning-andor-throwing-errors
    throw new errors_1.Airror(STATUS_CODE_TO_AIRROR[status] || {
        type: 'UNKNOWN_ERROR',
        message: `Unknown error returned: ${JSON.stringify(body || '<Empty response body>')}`,
        statusCode: status,
    });
};
exports.parseAirrorResponse = parseAirrorResponse;
const parseResponseBody = (response) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isJsonResponse = ((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) || false;
    const responseText = yield response.text();
    return isJsonResponse && responseText
        ? JSON.parse(responseText)
        : responseText || undefined;
});
exports.parseResponseBody = parseResponseBody;
//# sourceMappingURL=utils.js.map